import { Link } from 'react-router-dom';

export default function PageHero({ title, children }) {
  return (
    <section className="page-hero">
      <div className="wrap">
        <p className="crumbs">
          <Link to="/">Home</Link>
          <span aria-hidden="true"> / </span>
          <span>{title}</span>
        </p>
        <h1>{title}</h1>
        {children && <p className="page-hero-lead">{children}</p>}
      </div>
    </section>
  );
}
